import { day, hasValue, type Maybe, utc } from '@vrplatform/utils';

type ReservationDate = Maybe<string>;

export const formatReservationDates = (
  checkIn: ReservationDate,
  checkOut: ReservationDate
) => {
  if (!checkIn || !checkOut) {
    return [checkIn, checkOut]
      .filter(hasValue)
      .map((date) => utc(date).format('MMM DD, YYYY'))
      .join(' - ');
  }

  const checkInDay = utc(checkIn);
  const checkOutDay = utc(checkOut);

  if (!checkInDay.isValid() || !checkOutDay.isValid()) {
    return [checkIn, checkOut]
      .filter(hasValue)
      .map((date) => utc(date).format('MMM DD, YYYY'))
      .join(' - ');
  }

  if (checkInDay.isSame(checkOutDay, 'day')) {
    return checkInDay.format('MMM DD, YYYY');
  }

  const sameYear = checkInDay.isSame(checkOutDay, 'year');
  const sameMonth = checkInDay.isSame(checkOutDay, 'month');

  if (!sameYear) {
    return `${checkInDay.format('MMM DD, YYYY')} - ${checkOutDay.format(
      'MMM DD, YYYY'
    )}`;
  }

  if (sameMonth) {
    return `${checkInDay.format('MMM DD')} - ${checkOutDay.format('DD, YYYY')}`;
  }

  return `${checkInDay.format('MMM DD')} - ${checkOutDay.format(
    'MMM DD, YYYY'
  )}`;
};

export const getReservationNights = (
  checkIn: ReservationDate,
  checkOut: ReservationDate
) => {
  if (!checkIn || !checkOut) return null;

  const checkInDay = day(checkIn);
  const checkOutDay = day(checkOut);

  if (!checkInDay.isValid() || !checkOutDay.isValid()) return null;

  const nights = checkOutDay.diff(checkInDay, 'day');

  return nights > 0 ? nights : null;
};
